module.exports = __webpack_public_path__ + "img/acts-document.ebc3bb2e.svg";